import { render } from "./loyalty-points-messaging.vue?vue&type=template&id=3380de5f"
import script from "./loyalty-points-messaging.vue?vue&type=script&lang=js"
export * from "./loyalty-points-messaging.vue?vue&type=script&lang=js"

import "./loyalty-points-messaging.vue?vue&type=style&index=0&id=3380de5f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__